import React from 'react';
import { connect } from 'react-redux';
import _ from 'lodash';
import PropTypes from 'prop-types';
import { withRouter } from 'react-router-dom';
import withForm from 'modules/common/hoc/withForm';
import Modal from 'modules/common/components/Modal';
import * as actions from '../actions';

function ViewOrFees({ fees }) {
  return (
    <Modal.Body>
      <div
        style={{
          display: 'flex',
          flexDirection: 'column',
          justifyContent: 'center',
          marginBottom: '20px',
          overflow: 'auto',
        }}
      >
        <div style={{ height: '600px', width: '100%', overflow: 'auto' }}>
          <div className="table-responsive p-3" style={{ width: '100%' }}>
            <table className="table table-striped table-sm table-bordered table-hover">
              <thead className="table-header">
                <tr>
                  <th className="p-2">NAME</th>
                  <th className="p-2">AMOUNT</th>
                </tr>
              </thead>
              <tbody className="table-details">
                {fees.map((data) => (
                  <tr key={_.get(data, 'id')}>
                    <td>{_.get(data, 'name') || 'N/A'}</td>
                    <td>{_.get(data, 'amount') || 'N/A'}</td>  
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </Modal.Body>
  );
}

ViewOrFees.propTypes = {
  fees: PropTypes.instanceOf(Object).isRequired
};

const mapStateToProps = () => ({});

const enhance = _.flowRight([
  withForm,
  withRouter,
  connect(mapStateToProps, {
    ...actions,
  }),
]);

export default enhance(ViewOrFees);
